import { render, staticRenderFns } from "./zoomImage.vue?vue&type=template&id=6d62f6f2&"
import script from "./zoomImage.vue?vue&type=script&lang=js&"
export * from "./zoomImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports